import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Icon } from "semantic-ui-react";

import { classNames } from "utils/common";

import type { Question } from "models";
import type { CSSProperties } from "react";

type SortableQuestionProps = {
  sortableId: string;
  question: Question;
  canEdit: boolean;
  onRemove: () => void;
};

export const SortableQuestion = ({ sortableId, question, canEdit, onRemove }: SortableQuestionProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: sortableId });

  const style: CSSProperties = { transform: CSS.Translate.toString(transform), transition };

  return (
    <div ref={setNodeRef} style={style} className={`question-item ${classNames({ "is-sortable": canEdit, "is-dragging": isDragging })}`} {...attributes} {...listeners}>
      {canEdit && <Icon className="xmark" onClick={onRemove} />}
      <span>{question.title}</span>
    </div>
  );
};
